import { siteConfig } from "../content/discoveryContent";

const ensureMetaTag = (selector, attributes) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    document.head.appendChild(node);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
};

const ensureLinkTag = (selector, attributes) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("link");
    document.head.appendChild(node);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
};

const ensureScriptTag = (id, json) => {
  let node = document.head.querySelector(`#${id}`);
  if (!node) {
    node = document.createElement("script");
    node.type = "application/ld+json";
    node.id = id;
    document.head.appendChild(node);
  }

  node.textContent = JSON.stringify(json);
};

export const absoluteUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${siteConfig.baseUrl}${normalizedPath}`;
};

export const applySeo = ({
  title,
  description,
  path = "/",
  image = siteConfig.defaultOgImage,
  keywords = [],
  jsonLd = [],
}) => {
  document.title = title || siteConfig.defaultTitle;

  const canonicalUrl = absoluteUrl(path);

  ensureMetaTag('meta[name="description"]', {
    name: "description",
    content: description || siteConfig.defaultDescription,
  });
  ensureMetaTag('meta[name="keywords"]', {
    name: "keywords",
    content: keywords.join(", "),
  });
  ensureMetaTag('meta[property="og:title"]', {
    property: "og:title",
    content: title || siteConfig.defaultTitle,
  });
  ensureMetaTag('meta[property="og:description"]', {
    property: "og:description",
    content: description || siteConfig.defaultDescription,
  });
  ensureMetaTag('meta[property="og:type"]', {
    property: "og:type",
    content: "website",
  });
  ensureMetaTag('meta[property="og:url"]', {
    property: "og:url",
    content: canonicalUrl,
  });
  ensureMetaTag('meta[property="og:image"]', {
    property: "og:image",
    content: image,
  });
  ensureMetaTag('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  ensureMetaTag('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: title || siteConfig.defaultTitle,
  });
  ensureMetaTag('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: description || siteConfig.defaultDescription,
  });
  ensureMetaTag('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: image,
  });
  ensureLinkTag('link[rel="canonical"]', {
    rel: "canonical",
    href: canonicalUrl,
  });

  ensureScriptTag("organization-schema", siteConfig.organizationSchema);

  jsonLd.forEach((item, index) => {
    ensureScriptTag(`page-schema-${index}`, item);
  });

  const extraSchemas = document.head.querySelectorAll('script[id^="page-schema-"]');
  extraSchemas.forEach((node, index) => {
    if (index >= jsonLd.length) {
      node.remove();
    }
  });
};
